module.exports = __webpack_public_path__ + "img/1.6019b4e6.png";